import { Box, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import ConfirmationPopup from "../../../../../components/common/ConfirmationPopup/ConfirmationPopup.tsx";
import styles from "./PhotoshopInstallationPopup.module.scss";

type ModelAccessPopupProps = {
	open: boolean;
	onClose: () => void;
	onClick: () => void;
	loading?: boolean;
	disabled?: boolean;
	pageName?: string;
};

const PhotoshopInstallationPopup = ({ open, loading, disabled, onClose, onClick }: ModelAccessPopupProps) => {
	const { t } = useTranslation("tg", { keyPrefix: "models.popups.photoshopInstallationGuide" });

	return (
		<ConfirmationPopup
			open={open}
			onClick={onClick}
			title={t("header")}
			maxWidth="616px"
			hideCancel={true}
			confirmButtonText={t(`primaryBtn`)}
			onClose={onClose}
			loading={loading}
			disableConfirm={disabled}
			paperClassName={styles.paperWrap}
		>
			<Box>
				<Typography>{t("description")}</Typography>
			</Box>
		</ConfirmationPopup>
	);
};

export default observer(PhotoshopInstallationPopup);
